export default __webpack_public_path__ + "static/media/twitter.88a3f4cf.svg";